/* eslint-disable react/jsx-filename-extension */
import {
  Messenger,
  MessengerSolid,
  Instagram,
  InstagramSolid,
  LiveChat,
  EmailClosed,
  //  Outlook,
  Google,
} from '@groovehq/internal-design-system/lib/assets/icons'
import thumbsUpImg from '@groovehq/internal-design-system/lib/assets/images/thumbs-up.png'
import gmailImg from '@groovehq/internal-design-system/lib/assets/images/auth-gmail.png'
import {
  DRAWER_TYPE_SAMPLE,
  DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS,
  DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
  DRAWER_TYPE_CHANNELS_AUTHENTICATE,
  DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
} from 'ducks/drawers/types'
import {
  DRAWER_ID_FOLDERS_SELECT_EMAIL,
  DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
  DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
  DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
  DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
} from 'ducks/drawers/ids'

// Drawer ids are generated using

export const CHANNEL_MAIN_TYPES = {
  email: {
    drawer: {
      id: DRAWER_ID_FOLDERS_SELECT_EMAIL,
      type: DRAWER_TYPE_CHANNELS_SELECT_EMAIL,
      closeIgnoresStack: true,
    },
    name: 'Email',
    icon: <EmailClosed />,
    title: `Add an Email ${app.t('mailbox')}`,
  },
  chat: {
    drawer: {
      id: null,
      type: DRAWER_TYPE_SAMPLE,
    },
    name: 'Live chat',
    icon: <LiveChat />,
    title: 'Add Live chat to your site or app',
  },
  messenger: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS,
    },
    name: 'Messenger',
    icon: <Messenger />,
    solidIcon: <MessengerSolid />,
    title: 'Add Facebook Messenger',
    brandColor: '#0084ff',
  },
  instagram: {
    drawer: {
      id: null,
      type: DRAWER_TYPE_SAMPLE,
    },
    name: 'Instagram',
    icon: <Instagram />,
    solidIcon: <InstagramSolid />,
    title: 'Add Instagram',
    brandColor: '#0495f6',
  },
}

export const CHANNEL_EMAIL_TYPES = {
  google: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS_OAUTH,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS_OAUTH,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_AUTHENTICATE,
      type: DRAWER_TYPE_CHANNELS_AUTHENTICATE,
      closeIgnoresStack: true,
    },
    name: 'Google',
    icon: <Google />,
    headerImg: gmailImg,
    title: 'Add a Gmail account',
    editTitle: 'Link your Gmail account',
  },
  // Disabled until we have time to propertly integrate outlook
  // using oauth integrations
  // outlook: {
  //   drawer: {
  //     id: null,
  //     type: DRAWER_TYPE_SAMPLE,
  //   },
  //   name: 'Outlook',
  //   icon: <Outlook />,
  //   headerImg: thumbsUpImg,
  //   title: 'Link up your Outlook account',
  // },
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNEL_DETAILS,
      type: DRAWER_TYPE_CHANNELS_CHANNEL_DETAILS,
      closeIgnoresStack: true,
    },
    editDrawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
      type: DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
      closeIgnoresStack: true,
    },
    name: 'Other email client',
    icon: <EmailClosed />,
    headerImg: thumbsUpImg,
    title: 'Forward your emails to Groove',
    editTitle: 'Forward your emails to Groove',
  },
}

export const CHANNEL_TYPES = {
  ...CHANNEL_MAIN_TYPES,
  ...CHANNEL_EMAIL_TYPES,
}

export const drawerConfig = {
  DEFAULT_DRAWER_TITLE: `New ${app.t('mailbox')}`,
}
